import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from '../../styles/GlobalStyles';
import MediaBreakDown from '../../styles/MediaBreakDown';

export const Hero = styled.div`
  margin: 110px auto 77px;
  width: 100%;
  max-width: 747px;
  text-align: center;
  ${MediaBreakDown.md`
    margin: 80px auto 50px;
  `}
`;

export const HeroHeading = styled.h1`
  font-size: 3.375rem;
  line-height: 4.05rem;
  margin-bottom: ${props => props.mb};
  ${MediaBreakDown.md`
    font-size: 1.75rem;
    line-height: 2.1rem;
  `}
`;

HeroHeading.propTypes = {
  mb: PropTypes.string,
};

HeroHeading.defaultProps = {
  mb: '0px',
};

export const SectionTitle = styled.h2`
  font-size: 2.75rem;
  line-height: 3.4rem;
  margin-bottom: ${props => props.mb};
  ${MediaBreakDown.md`
    font-size: 1.75rem;
    line-height: 2.1rem;
  `}
`;
SectionTitle.propTypes = {
  mb: PropTypes.string,
};

SectionTitle.defaultProps = {
  mb: '0px',
};

export const SmallSectionTitle = styled.h2`
  font-size: 2.25rem;
  line-height: 2.7rem;
  margin-bottom: ${props => props.mb};
  ${MediaBreakDown.md`
    font-size: 1.75rem;
    line-height: 2.1rem;
  `}
`;
SmallSectionTitle.propTypes = {
  mb: PropTypes.string,
};

SmallSectionTitle.defaultProps = {
  mb: '0px',
};

export const MediumTitleMobile = styled.h2`
  margin-top: ${props => props.mt};
  font-size: 1.5rem;
  line-height: 1.8rem;
`;

MediumTitleMobile.propTypes = {
  mt: PropTypes.string,
};

MediumTitleMobile.defaultProps = {
  mt: '0',
};

export const SmallTitle = styled.h3`
  font-size: 1.75rem;
  line-height: 2.1rem;
  margin-top: ${props => props.mt};
  margin-bottom: ${props => props.mb};
  ${MediaBreakDown.md`
    font-size: 1.125rem;
    line-height: 1.35rem;
  `}
`;

SmallTitle.propTypes = {
  mt: PropTypes.string,
  mb: PropTypes.string,
};

SmallTitle.defaultProps = {
  mt: '0',
  mb: '18px',
};


export const BodyText = styled.p`
  font-size: 1rem;
  line-height: 1.2rem;
  margin-top: ${props => props.mt};
  margin-bottom: ${props => props.mb};
`;

BodyText.propTypes = {
  mt: PropTypes.string,
  mb: PropTypes.string,
};

BodyText.defaultProps = {
  mt: '12px',
  mb: '12px',
};


export const ContentWrap = styled.div`
  width: 100%;
  max-width: 900px;
  margin: auto;
  margin-bottom: ${props => props.mb};
  h1, h2 {
    margin-top: 1.787rem;
  }
  h3, h4, h5 {
    margin-bottom: 1rem;
  }
  a {
    color: ${theme.textColor.blueText};
  }
  img {
    border-radius: 6px;
  }
  blockquote {
    background: ${theme.blockquote.dark};
    border-left: 10px solid ${theme.borderColor.blueBorder};
    margin: 1.5em 0;
    padding: 0.5em 10px;

    & > p {
      display: inline;
      margin: 0;
    }
  }
  ${MediaBreakDown.md`
    margin-bottom: 50px;
  `}
`;

ContentWrap.propTypes = {
  mb: PropTypes.string,
};

ContentWrap.defaultProps = {
  mb: '100px',
};
